import { extendTheme } from '@chakra-ui/react';
import styles from './styles';
import Button from './components/Button';
import Alert from './components/Alert';
import Checkbox from './components/Checkbox';
import Input from './components/Input';
import Switch from './components/Switch';
import { withProse } from '@nikolovlazar/chakra-ui-prose';

const overrides = {
  colors: {
    primary: '#00B3B0',
    primaryOpaque: '#00B3B00D',
    primaryDark: '#2a6380',
    secondary: '#F3F6F9',
    lightGreen: '#CDDE54',
    black: '#212121',
    gray: {
      500: '#F5F5F5',
    },
    lightGray: {
      400: '#E5EAEE',
      500: '#BFBFBF',
      600: '#E5E5E5',
    },
  },
  styles,
  components: {
    Button,
    Alert,
    Checkbox,
    Input,
    Switch
  },
};

export default extendTheme(overrides, withProse());
